import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import * as MessageActions from '../../common/messageBox/actions/actions';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {paths} from '../../common/dictionaries/urls';
import {history} from '../../common/store';

export const fetchVehicleTypeCatalog = () =>
  apiActionCreator({
    'endpoint': '/vehicles-invoice/invoiceTypeCatalog',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_VEHICLES_TYPES_LIST,
      ActionTypes.FETCHED_VEHICLES_TYPES_LIST,
      [
        ActionTypes.FETCHED_VEHICLES_TYPES_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchCandidateVehicles = (dealerId, type, anticipatedInvoice) => {
  const params = `dealerId=${dealerId}&type=${type}&anticipatedInvoice=${anticipatedInvoice}`;
  return apiActionCreator({
    'endpoint': `/vehicles-invoice/vehicleInvoiceCandidate?${params}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_CANDIDATES_VEHICLES,
      ActionTypes.FETCHED_CANDIDATES_VEHICLES,
      [
        ActionTypes.FETCHED_CANDIDATES_VEHICLES_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const clearCandidateVehicles = () => {
  return {
    'type': ActionTypes.CLEAR_CANDIDATES_VEHICLES,
  };
};

export const fetchDispatchOrder = (orderNum) =>
  apiActionCreator({
    'endpoint': `/vehicles-invoice/vehicleInvoiceOrders?orderId=${orderNum}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_DISPATCH_ORDER,
      ActionTypes.FETCHED_DISPATCH_ORDER,
      [
        ActionTypes.FETCHED_DISPATCH_ORDER_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const clearDispatchOrder = () => {
  return {
    'type': ActionTypes.CLEAR_DISPATCH_ORDER,
  };
};

export const editDispatchOrder = (orderNum, data) =>
  apiActionCreator({
    'endpoint': `/vehicles-invoice/vehicleInvoiceOrder?orderId=${orderNum}`,
    'authenticated': true,
    'types': [
      ActionTypes.SAVING_DISPATCH_ORDER,
      [
        ActionTypes.SAVED_DISPATCH_ORDER,
        MessageActions.addMessageBoxInfo('Orden de despacho guardada satisfactoriamente'),
      ],
      [
        ActionTypes.SAVED_DISPATCH_ORDER_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'contentType': 'application/json',
    'data': data,
  });
  
export const addDispatchOrder = (data) => {
  return apiActionCreator({
    'endpoint': '/vehicles-invoice/vehicleInvoiceOrder',
    'authenticated': true,
    'types': [
      ActionTypes.SAVING_DISPATCH_ORDER,
      [
        (resp) => {
          history.replace(paths.DispatchOrdersEdit.replace(':code', resp.orderId));
          return {
            'type': ActionTypes.SAVED_DISPATCH_ORDER,
          };
        },
        ActionTypes.SAVED_DISPATCH_ORDER,
        MessageActions.addMessageBoxInfo('Orden de despacho creada satisfactoriamente'),
      ],
      [
        ActionTypes.SAVED_DISPATCH_ORDER_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'contentType': 'application/json',
    'data': data,
  });
};

export const approveDispatchOrder = (data) =>
  apiActionCreator({
    'endpoint': '/vehicles-invoice/approval',
    'authenticated': true,
    'types': [
      ActionTypes.APPROVING_DISPATCH_ORDER,
      [
        ActionTypes.APPROVED_DISPATCH_ORDER,
        MessageActions.addMessageBoxInfo('Proceso de aprobación realizado correctamente.'),
      ],
      [
        ActionTypes.APPROVED_DISPATCH_ORDER_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'contentType': 'application/json',
    'data': data,
  });


export const cancelDispatchOrder = (orderNum, action) =>
  apiActionCreator({
    'endpoint': `/vehicles-invoice/vehicleInvoiceOrder?orderId=${orderNum}&action=${action}`,
    'authenticated': true,
    'types': [
      ActionTypes.CANCELLING_DISPATCH_ORDER,
      [
        ActionTypes.CANCELLED_DISPATCH_ORDER,
        MessageActions.addMessageBoxInfo(`Orden ${action === 'A' ? 'anulada' : 'eliminada'} exitosamente.`),
      ],
      [
        ActionTypes.CANCELLED_DISPATCH_ORDER_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'DELETE',
    'contentType': 'application/json',
  });
